import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PackageExpiryReportContent from "./PackageExpiryReportContent";

const MembershipExpiryPage = () => (
  <PackageExpiryReportContent
    type="membership"
    title={translate("analyticsPage.membership.report_status")}
    backTo={PATHS.ANALYTICS}
  />
);

export default MembershipExpiryPage;
